import { render, staticRenderFns } from "./AlternativeList.vue?vue&type=template&id=d750f16c"
import script from "./AlternativeList.vue?vue&type=script&lang=js"
export * from "./AlternativeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports